// extracted by mini-css-extract-plugin
module.exports = {"slider":"index-module--slider--2pqyj"};